import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { t as translate } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("jspa_lang") || "id");

  useEffect(() => {
    localStorage.setItem("jspa_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback((key) => translate(key, lang), [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, rtl: lang === "ar" }),
    [lang, t]
  );

  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
}
